import script from "./NoNotifications.vue?vue&type=script&setup=true&lang=js"
export * from "./NoNotifications.vue?vue&type=script&setup=true&lang=js"

import "./NoNotifications.vue?vue&type=style&index=0&id=5df18275&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5df18275"]])

export default __exports__